import { Pipe, PipeTransform } from '@angular/core';
@Pipe({ name: 'EmployeeSearch' })
export class EmployeeSearchPipe implements PipeTransform {
  transform(value, args?): Array<any> {
    const searchText = new RegExp(args, 'ig');
    if (value) {
      return value.filter(employee => {
        if (employee.firstName || employee.lastName) {
          if (employee.firstName.search(searchText) !== -1 || employee.lastName.search(searchText) !== -1 || employee.employeeId.search(searchText) !== -1)  {
            return true;
          }
          return false;
        }
        return false;
      });
    }
    return [];
  }
}
